export default {
  ADD_OWNER_HOUSE_PROPERTY_MORE: "setOwnerHousePropertieMore",
  ADD_OWNER_HOUSE_PROPERTY_ANALYZE: "setOwnerHousePropertieAnalyze",
  ADD_OWNER_HOUSE_PROPERTY_ANALYZE_ALL: "setOwnerHousePropertieAnalyzeAll",
  SET_PARTIAL_BUY_PROPERTY_SEQS: "setPartialBuyPropertySeqs",
  CLEAR_PARTIAL_BUY_PROPERTY_SEQS: "clearPartialBuyPropertySeqs",
  SET_PAID_OWNER_NAMES: "setPaidOwnerNames",
  CLEAR_PAID_OWNER_NAMES: "clearPaidOwnerNames",

  PARTIAL_BUY_THRESHOLD: 40, // N채 이상이면 부분결제 모드.
  PARTIAL_BUY_LOAD_MORE_THRESHOLD: 10, // N채 이상이면 더보기 버튼 표시.
};
